import {
  ReviewCharacteristic,
  ReviewResult,
  SuggestionValueKeys,
} from 'types/check';

export const ReviewResultColor = Object.freeze({
  [ReviewResult.fail]: '#f92424',
  [ReviewResult.pass]: '#5cd068',
  [ReviewResult.skip]: '#E3E3E3',
  [ReviewResult.warning]: '#FFBE00',
});

export const ReviewCharacteristicReadable = Object.freeze({
  [ReviewCharacteristic.fontType]: 'typeface',
  [ReviewCharacteristic.fontColor]: 'fontColor',
  [ReviewCharacteristic.fontSize]: 'fontSize',
  [ReviewCharacteristic.ssiCheck]: 'ssiCheck',
  [ReviewCharacteristic.ssiAnnotation]: 'ssiAnnotation',
  [ReviewCharacteristic.ssiPresence]: 'ssiPresence',
  [ReviewCharacteristic.productName]: 'productNames',
});

export const ReviewSuggestionValueField = Object.freeze({
  [ReviewCharacteristic.fontType]: SuggestionValueKeys.fontFamily,
  [ReviewCharacteristic.fontColor]: [
    SuggestionValueKeys.hex,
    SuggestionValueKeys.rgb,
  ],
  [ReviewCharacteristic.fontSize]: SuggestionValueKeys.size,
  [ReviewCharacteristic.ssiCheck]: SuggestionValueKeys.ssiCheck,
  [ReviewCharacteristic.ssiAnnotation]: SuggestionValueKeys.ssiAnnotation,
  [ReviewCharacteristic.ssiPresence]: SuggestionValueKeys.brandingType,
  [ReviewCharacteristic.productName]: SuggestionValueKeys.brandingType,
  [ReviewCharacteristic.claimText]: SuggestionValueKeys.claimText,
  [ReviewCharacteristic.alignedClaimText]: SuggestionValueKeys.alignedClaimText,
});

export const ReviewSuggestionColorType = Object.freeze({
  [SuggestionValueKeys.rgb]: 'RGB',
  [SuggestionValueKeys.hex]: 'HEX',
});

export const AlertType = {
  total: 'totalAlerts',
  safety: 'totalSafetyAlerts',
  style: 'totalStyleAlerts',
} as const;

export enum TabNames {
  total = 'total',
  safety = 'safety',
  style = 'style',
}

export const QualityChecksTabs = {
  total: 'Total',
  safety: 'Safety',
  style: 'Style',
} as const;

export const Value = {
  zero: '0',
  zeroPercentage: '0%',
} as const;
